<!-- Business Tycoon -->
<template>
  <div class="bc-list-page">
    <!-- 페이지 헤더 -->
    <!-- <div class="page-header">
      <div>
        <h1>사업왕 성공전략</h1>
        <p>사업왕의 성공 비결과 목표를 확인하고 공유할 수 있습니다.</p>
      </div>

      <div v-if="selectedShopCd" class="selected-shop">
        <span class="selected-dot"></span>
        <span>선택된 점포</span>
        <strong>{{ selectedShopCd }}</strong>
      </div>
    </div> -->

    <!-- 메인 영역 -->
    <div class="layout">
      <!-- =========================
           왼쪽 : 성공전략 입력
      ========================== -->
      <div class="left-form">
        <div class="section-card">
          <div class="section-header">
            <div>
              <span class="section-badge">SUCCESS</span>
              <h2>사업왕 성공전략</h2>
              <p>사업왕의 목표와 성공 비결을 작성해 주세요.</p>
            </div>
            <div v-if="selectedShopCd" class="selected-shop">
              <span class="selected-dot"></span>
              <span>선택된 사업왕</span>
              <strong>{{ selectedShopKingNm }}</strong>
            </div>
          </div>

          <table class="input-table">
            <tbody>
              <tr>
                <th>
                  당월 사업소득<br>목표 금액
                </th>

                <td>
                  <div class="income-input">
                    <input
                      v-model="formData.incomeTarget"
                      :readonly="!canEdit"
                      type="text"
                      placeholder="목표금액 입력"
                    />
                    <span>만원</span>
                  </div>
                </td>
              </tr>

              <tr>
                <th>성공비결 공유목적</th>
                <td>
                  <textarea
                    v-model="formData.successPurpose"
                    :readonly="!canEdit"
                    placeholder="성공비결을 공유하는 목적을 작성해 주세요."
                  ></textarea>
                </td>
              </tr>

              <tr>
                <th>고객부문</th>
                <td>
                  <textarea
                    v-model="formData.customerSection"
                    :readonly="!canEdit"
                    placeholder="고객 관리 및 응대에 대한 성공전략을 작성해 주세요."
                  ></textarea>
                </td>
              </tr>

              <tr>
                <th>직원부문</th>
                <td>
                  <textarea
                    v-model="formData.staffSection"
                    :readonly="!canEdit"
                    placeholder="직원 관리 및 조직 운영에 대한 내용을 작성해 주세요."
                  ></textarea>
                </td>
              </tr>

              <tr>
                <th>판매수량부문</th>
                <td>
                  <textarea
                    v-model="formData.salesQtySection"
                    :readonly="!canEdit"
                    placeholder="판매수량을 늘리기 위한 전략을 작성해 주세요."
                  ></textarea>
                </td>
              </tr>

              <tr>
                <th>사업소득증여부문</th>
                <td>
                  <textarea
                    v-model="formData.businessIncomeSection"
                    :readonly="!canEdit"
                    placeholder="사업소득 증대를 위한 방법을 작성해 주세요."
                  ></textarea>
                </td>
              </tr>

              <tr>
                <th>기타부문</th>
                <td>
                  <textarea
                    v-model="formData.etcSection"
                    :readonly="!canEdit"
                    placeholder="기타 성공전략이나 노하우를 작성해 주세요."
                  ></textarea>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- 저장 -->
          <div v-if="canEdit" class="form-footer">
            <span class="edit-guide">
              ※ 본인 점포의 내용만 수정할 수 있습니다.
            </span>

            <button type="button" class="save-btn" @click="saveForm">
              <span>✓</span>
              저장
            </button>
          </div>
        </div>
      </div>

      <!-- =========================
           오른쪽 : 사업왕 목록
      ========================== -->
      <div class="right-grid">
        <div class="section-card grid-card">
          <div class="section-header grid-header">
            <div>
              <span class="section-badge">RANKING</span>
              <h2>사업왕 TOP</h2>
              <p>사업왕을 선택하면 상세 성공전략을 확인할 수 있습니다.</p>
            </div>

            <div class="ranking-info">
              총 <strong>{{ topRowData.length }}</strong
              >명
            </div>
          </div>

          <div class="grid-wrapper">
            <ag-grid-vue
              class="ag-bc-balham"
              style="width: 100%; height: 300px"
              :columnDefs="topColumnDefs"
              :rowData="topRowData"
              :gridOptions="topGridOptions"
              :theme="theme"
              @rowClicked="onShopClicked"
            />
          </div>
        </div>

        <!-- =========================
             상세 구성원
        ========================== -->
        <div v-if="detailVisible" class="section-card detail-card">
          <div class="section-header grid-header">
            <div>
              <span class="section-badge detail-badge">MEMBERS</span>
              <h2>사업왕 구성원</h2>
              <p>선택한 사업왕에 소속된 점포입니다.</p>
            </div>

            <div class="ranking-info">
              총 <strong>{{ detailRowData.length }}</strong
              >개 점포
            </div>
          </div>

          <div class="grid-wrapper">
            <ag-grid-vue
              class="ag-bc-balham"
              style="width: 100%; height: 300px"
              :columnDefs="detailColumnDefs"
              :rowData="detailRowData"
              :gridOptions="detailGridOptions"
              :theme="theme"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 관리자용 엑셀 붙여넣기 영역 -->
    <div
      v-if="
        userInfo &&
        userInfo.OGN_FG === '00' &&
        ['TB관리자'].includes(this.userInfo.userId)
      "
      class="manage-panel"
    >
      <div class="manage-title">
        <span class="manage-icon">⚙</span>
        <div>
          <strong>관리자 데이터 관리</strong>
          <small>엑셀 데이터를 붙여넣어 사업왕 정보를 일괄 등록합니다.</small>
        </div>
      </div>

      <div class="manage-input">
        <textarea
          v-model="pasteData"
          placeholder="엑셀에서 데이터를 복사한 후 이곳에 붙여넣어 주세요."
        ></textarea>

        <button class="manage-save-btn" @click="saveData">저장하기</button>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { themeBalham } from "ag-grid-community";
import axios from "axios";

export default {
  components: { AgGridVue },
  data() {
    return {
      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        borderColor: "#808080",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: "100%",
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      userInfo: null, // 로그인한 사용자 정보
      pasteData: "",
      myShopCd: "",
      selectedShopCd: "",
      selectedShopKingNm: "",

      canEdit: false,

      formData: {
        incomeTarget: "", // 당월사업 소득 목표금액
        successPurpose: "", // 성공비결 공유목적
        customerSection: "", // 고객부문
        staffSection: "", // 직원부문
        salesQtySection: "", // 판매수량부문
        businessIncomeSection: "", // 사업소득증여부문
        etcSection: "", // 기타부문
      },

      selectedItem: null,
      detailVisible: null,

      topRowData: [],
      topColumnDefs: [
        {
          headerName: "랭킹",
          field: "RANKING",
          width: 38,
          cellStyle: { textAlign: "center", backgroundColor: "#ffffc0" },
        },
        { headerName: "사업왕", field: "REGION_NM", flex: 1.4 },
        { headerName: "점명", field: "SHOP_NM", flex: 1.2 },
        { headerName: "사업주", field: "OWNER_NM", flex: 0.8 },
        {
          headerName: "목표수익",
          field: "TARGET_PROFIT",
          flex: 1,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
        // 260907 흑적자(PROFIT_LOSS) 에서 당월수익(PROFIT) 수정 팀장님
        {
          headerName: "당월수익", 
          field: "PROFIT",
          flex: 1,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
        {
          headerName: "판매수량",
          field: "TOTAL_QTY",
          flex: 1,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
        {
          headerName: "예상수량",
          field: "EXPECTED_SALE_QTY",
          flex: 1,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
        {
          headerName: "최고수량",
          field: "MAX_QTY",
          flex: 1,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
        {
          headerName: "최고대비",
          field: "ACHIEVEMENT_RATE",
          flex: 1,
          valueFormatter: (p) => (p.value || 0) + "%",
        },
        { headerName: "SHOP_CD", field: "SHOP_CD", hide: true }, // 숨김 컬럼
        { headerName: "SK_ID", field: "SK_ID", hide: true }, // 숨김 컬럼
      ],
      topGridOptions: {
        headerHeight: 30,
        rowSelection: 'single',
        rowHeight: 30,
        defaultColDef: {
          resizable: true,
          cellStyle: { textAlign: "center" },
          headerStyle: {
            backgroundColor: "#ffffc0",
            color: "black",
          },
        },
      },

      detailRowData: [],
      detailColumnDefs: [
        {
          headerName: "랭킹",
          field: "RANKING",
          width: 38,
          cellStyle: { textAlign: "center", backgroundColor: "#ffffc0" },
        },
        // { headerName: "사업왕", field: "REGION_NM", flex: 1.4 },
        { headerName: "점번", field: "VAN_BIZ_NO", flex: 0.8 },
        { headerName: "점명", field: "SHOP_NM", flex: 1.2 },
        { headerName: "사업주", field: "SHOP_MASTER_NM", flex: 0.8 },
        {
          headerName: "목표수익",
          field: "TARGET_PROFIT",
          flex: 1,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
        // 260907 흑적자(PROFIT_LOSS) 에서 당월수익(PROFIT) 수정 팀장님
        {
          headerName: "당월수익",
          field: "PROFIT",
          flex: 1,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
        {
          headerName: "판매수량",
          field: "TOTAL_QTY",
          flex: 1,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
        {
          headerName: "예상수량",
          field: "EXPECTED_SALE_QTY",
          flex: 1,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
        {
          headerName: "최고수량",
          field: "MAX_QTY",
          flex: 1,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
        {
          headerName: "최고대비",
          field: "ACHIEVEMENT_RATE",
          flex: 1,
          valueFormatter: (p) => (p.value || 0) + "%",
        },
        { headerName: "SHOP_CD", field: "SHOP_CD", hide: true }, // 숨김 컬럼
        { headerName: "SK_ID", field: "SK_ID", hide: true }, // 숨김 컬럼
      ],
      detailGridOptions: {
        headerHeight: 30,
        rowHeight: 30,
        defaultColDef: {
          resizable: true,
          cellStyle: { textAlign: "center" },
          headerStyle: {
            backgroundColor: "#ffffc0",
            color: "black",
          },
        },
      },
    
    };
  },

  mounted() {
    // localStorage에서 사용자 정보 불러오기
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);

      this.myShopCd = this.userInfo.SHOP_CD || "";
    }

    // 사업왕 목록 로드
    this.loadShopKingList();
  },

  methods: {
    async selectItem(item) {
      const skId = item.SK_ID;

      try {
        const response = await axios.get("/api/bcListPage/shopKingStore", {
          params: {
            skId: skId,
          },
        });

        if (response.data.success) {
          console.log("사업왕 소속 점포:", response.data.data);

          // 여기서 아래 그리드에 데이터 표시
          this.detailRowData = response.data.data;
          this.detailVisible = response.data.data;
        }
      } catch (err) {
        console.error("사업왕 점포 조회 실패:", err);
      }
    },
    async saveData() {
      // 데이터 유효성 검사
      if (!this.pasteData || this.pasteData.trim() === "") {
        alert("데이터를 입력해주세요.");
        return;
      }

      // 권한 체크 (추가 구현 가능)
      // if (!this.hasPermission("SAVE_SHOPKING")) {
      //   alert("저장 권한이 없습니다.");
      //   return;
      // }

      try {
        // 1. 붙여넣기 데이터 파싱 (탭/줄바꿈 기준)
        const rows = this.pasteData
          .trim()
          .split("\n")
          .map((line) =>
            line
              .split("\t")
              .map((cell) => cell.trim())
              .filter((cell) => cell !== ""),
          )
          .filter((row) => row.length > 0 && row[0]); // 빈 줄 제거

        if (rows.length === 0) {
          alert("유효한 데이터가 없습니다.");
          return;
        }

        console.log("파싱된 데이터:", rows);

        // 2. 서버로 데이터 전송
        const response = await axios.post("/api/bcListPage/saveList", { rows });

        if (response.data.success) {
          alert(response.data.message);

          // 3. 저장 완료 후 데이터 새로고침
          this.pasteData = "";
          await this.loadShopKingList();
        } else {
          alert("저장 실패: " + response.data.message);
        }
      } catch (err) {
        console.error("저장 중 오류:", err);
        alert("저장 실패: " + (err.response?.data?.message || err.message));
      }
    },

    /**
     * 사업왕 목록 조회
     */
    async loadShopKingList() {
      try {
        const response = await axios.get("/api/bcListPage/shopKingList");

        if (response.data.success) {
          this.topRowData = response.data.data;
        }
      } catch (err) {
        console.error("사업왕 목록 조회 실패:", err);
      }
    },

    async onShopClicked(params) {
      const row = params.data;
      // 동시에 selectItem도 호출
      this.selectItem(params.data);

      if (!row || !row.SHOP_CD) {
        return;
      }

      const shopCd = row.SHOP_CD;

      this.selectedShopCd = shopCd;
      this.selectedShopKingNm = row.REGION_NM || "";

      // 내 점포인지 확인
      this.canEdit = String(shopCd) === String(this.myShopCd);

      // 일단 빈 폼으로 초기화
      this.formData = {
        incomeTarget: "",
        successPurpose: "",
        customerSection: "",
        staffSection: "",
        salesQtySection: "",
        businessIncomeSection: "",
        etcSection: "",
      };

      try {
        const response = await axios.get(
          `/api/bcListPage/fetchShopKingForm/${shopCd}`,
        );

        if (response.data.success && response.data.data) {
          const data = response.data.data;

          this.formData = {
            incomeTarget: data.INCOME_TARGET || "",
            successPurpose: data.SUCCESS_PURPOSE || "",
            customerSection: data.CUSTOMER_SECTION || "",
            staffSection: data.STAFF_SECTION || "",
            salesQtySection: data.SALES_QTY_SECTION || "",
            businessIncomeSection: data.BUSINESS_INCOME_SECTION || "",
            etcSection: data.ETC_SECTION || "",
          };
        }
      } catch (error) {
        console.error("사업왕 내용 조회 실패:", error);

        alert("작성내용을 불러오지 못했습니다.");
      }
    },

    async saveForm() {
      if (!this.selectedShopCd) {
        alert("점포를 선택해주세요.");
        return;
      }

      // 보안상 한번 더 체크
      if (String(this.selectedShopCd) !== String(this.myShopCd)) {
        alert("본인 점포의 내용만 수정할 수 있습니다.");

        return;
      }

      // 현재월
      const now = new Date();

      const yyyy = now.getFullYear();

      const mm = String(now.getMonth() + 1).padStart(2, "0");

      const saleMM = `${yyyy}${mm}`;

      try {
        const response = await axios.post("/api/bcListPage/saveForm", {
          SHOP_CD: this.selectedShopCd,
          SALE_MM: saleMM,
          incomeTarget: this.formData.incomeTarget,
          successPurpose: this.formData.successPurpose,
          customerSection: this.formData.customerSection,
          staffSection: this.formData.staffSection,
          salesQtySection: this.formData.salesQtySection,
          businessIncomeSection: this.formData.businessIncomeSection,
          etcSection: this.formData.etcSection,
          userId: this.userInfo.userId,
        });

        if (response.data.success) {
          alert("저장되었습니다.");
        } else {
          alert(response.data.message || "저장에 실패했습니다.");
        }
      } catch (error) {
        console.error("저장 실패:", error);

        alert("저장 중 오류가 발생했습니다.");
      }
    },
  },
};
</script>

<style scoped>
/* =========================================================
   전체 페이지
========================================================= */

.bc-list-page {
  min-height: 100vh;
  padding: 6px;
  background: #f5f7fa;
  box-sizing: border-box;
  font-family: "Malgun Gothic", "Noto Sans KR", Arial, sans-serif;
  color: #1f2937;
}

/* =========================================================
   페이지 헤더
========================================================= */

/* .page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0px;
  padding: 12px 16px;

  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;

  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.05);
}

.page-header h1 {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.5px;
}

.page-header p {
  margin: 7px 0 0;
  color: #6b7280;
  font-size: 1rem;
} */

/* 선택 점포 */

.selected-shop {
  display: flex;
  align-items: center;
  gap: 7px;

  padding: 6px 10px;

  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 20px;

  font-size: 0.8rem;
  color: #64748b;
}

.selected-shop strong {
  color: #2563eb;
  font-size: 13px;
}

.selected-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22c55e;
}

/* =========================================================
   관리자 영역
========================================================= */

.manage-panel {
  margin-top: 10px;
  padding: 10px;

  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;

  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.05);
}

.manage-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.manage-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 34px;
  height: 34px;

  background: #f1f5f9;
  border-radius: 9px;

  font-size: 1rem;
}

.manage-title strong {
  display: block;
  font-size: 1rem;
}

.manage-title small {
  display: block;
  margin-top: 3px;
  color: #94a3b8;
  font-size: 0.8rem;
}

.manage-input {
  display: flex;
  gap: 10px;
}

.manage-input textarea {
  flex: 1;
  min-height: 75px;

  padding: 8px;

  border: 1px solid #d1d5db;
  border-radius: 8px;

  resize: vertical;
  outline: none;
  font-family: inherit;
  font-size: 0.9rem;
  box-sizing: border-box;
}

.manage-input textarea:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.manage-save-btn {
  align-self: flex-end;

  min-width: 90px;
  height: 40px;

  border: 0;
  border-radius: 8px;

  background: #374151;
  color: #ffffff;

  font-size: 0.9rem;
  font-weight: 600;

  cursor: pointer;
  transition: 0.2s;
}

.manage-save-btn:hover {
  background: #111827;
}

/* =========================================================
   좌우 레이아웃
========================================================= */

.layout {
  display: flex;
  align-items: flex-start;
  gap: 5px;
}

.left-form {
  flex: 1;
  min-width: 0;
}

.right-grid {
  flex: 1;
  min-width: 0;
}

/* =========================================================
   카드
========================================================= */

.section-card {
  overflow: hidden;

  background: #ffffff;

  border: 1px solid #e5e7eb;
  border-radius: 14px;

  box-shadow: 0 4px 15px rgba(15, 23, 42, 0.05);
}

.grid-card {
  margin-bottom: 5px;
}

/* =========================================================
   섹션 헤더
========================================================= */

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 5px 8px;

  border-bottom: 1px solid #eef0f3;
}

.section-header h2 {
  margin: 5px 0 0;

  font-size: 1.1rem;
  font-weight: 700;

  color: #111827;
}

.section-header p {
  margin: 5px 0 0;

  color: #9ca3af;
  font-size: 11px;
}

.section-badge {
  display: inline-flex;
  align-items: center;

  height: 10px;
  padding: 0 8px;

  border-radius: 5px;

  background: #eff6ff;
  color: #2563eb;

  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.6px;
}

.detail-badge {
  background: #f0fdf4;
  color: #16a34a;
}

/* =========================================================
   입력 테이블
========================================================= */

.input-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.input-table tr {
  border-bottom: 1px solid #eef0f3;
}

.input-table tr:last-child {
  border-bottom: 0;
}

.input-table th {
  width: 155px;

  padding: 10px 13px;

  background: #f8fafc;

  color: #475569;

  font-size: 0.9rem;
  font-weight: 600;

  text-align: left;
  vertical-align: middle;

  box-sizing: border-box;
}

.input-table td {
  padding: 5px 10px;

  background: #ffffff;

  box-sizing: border-box;
}

/* =========================================================
   필수 표시
========================================================= */

.required-dot {
  display: inline-block;

  width: 5px;
  height: 5px;

  margin-right: 5px;

  vertical-align: middle;

  border-radius: 50%;
  background: #ef4444;
}

/* =========================================================
   금액 입력
========================================================= */

.income-input {
  display: flex;
  align-items: center;
  gap: 7px;
}

.income-input input {
  width: 180px;
  height: 44px;

  padding: 0 9px;

  border: 1px solid #d1d5db;
  border-radius: 6px;

  outline: none;

  text-align: right;

  font-size: 14px;
  font-weight: 400;

  box-sizing: border-box;
  transition: 0.2s;
}

.income-input input:focus {
  border-color: #3b82f6;

  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.income-input input[readonly] {
  background: #f8fafc;
  color: #000000;
}

.income-input span {
  color: #64748b;
  font-size: 0.9rem;
}

/* =========================================================
   텍스트 입력
========================================================= */

.input-table textarea {
  display: block;

  width: 100%;
  min-height: 96px;

  padding: 5px 6px;

  border: 1px solid #d1d5db;
  border-radius: 6px;

  outline: none;

  resize: vertical;

  background: #ffffff;

  color: #374151;

  font-family: inherit;
  font-size: 0.9rem;
  line-height: 1.5;

  box-sizing: border-box;

  transition: 0.2s;
}

.input-table textarea:focus {
  border-color: #3b82f6;

  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
}

.input-table textarea[readonly] {
  background: #f8fafc;
  color: #000000;
}

.input-table textarea::placeholder {
  color: #b6bec9;
}

/* =========================================================
   저장 영역
========================================================= */

.form-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 8px 10px;

  background: #f8fafc;

  border-top: 1px solid #eef0f3;
}

.edit-guide {
  color: #94a3b8;
  font-size: 0.7rem;
}

.save-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  min-width: 85px;
  height: 36px;

  border: 0;
  border-radius: 7px;

  background: #2563eb;
  color: #ffffff;

  font-size: 12px;
  font-weight: 600;

  cursor: pointer;

  box-shadow: 0 3px 7px rgba(37, 99, 235, 0.2);

  transition: all 0.2s;
}

.save-btn:hover {
  background: #1d4ed8;

  transform: translateY(-1px);

  box-shadow: 0 5px 12px rgba(37, 99, 235, 0.25);
}

.save-btn:active {
  transform: translateY(0);
}

/* =========================================================
   그리드 영역
========================================================= */

.grid-wrapper {
  padding: 5px;
}

/* AG Grid */

:deep(.ag-bc-balham) {
  --ag-cell-horizontal-padding: 5px;
  --ag-cell-vertical-padding: 2px;

  --ag-border-color: #e5e7eb;

  --ag-row-border-color: #eef0f3;

  --ag-header-background-color: #f8fafc;

  --ag-header-foreground-color: #374151;

  --ag-font-family: "Malgun Gothic", "Noto Sans KR", Arial, sans-serif;

  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

/* Grid 헤더 */

:deep(.ag-bc-balham .ag-header) {
  border-bottom: 1px solid #dfe3e8;
}

:deep(.ag-bc-balham .ag-header-cell-comp-wrapper) {
  display: flex;

  align-items: center;
  justify-content: center;

  height: 100%;
}

:deep(.ag-bc-balham .ag-header-cell-label) {
  justify-content: center !important;

  align-items: center !important;

  white-space: pre-line;

  color: #374151;

  font-size: 0.8rem;
  font-weight: 600;
}

/* Grid 셀 */

:deep(.ag-bc-balham .ag-cell) {
  display: flex;
  justify-content: center !important;

  align-items: center;
  font-size: 0.8rem;

  color: #374151;
}

:deep(.ag-bc-balham .ag-row) {
  transition: background 0.15s;
}

:deep(.ag-bc-balham .ag-row:hover) {
  background: #f8fafc !important;
}

/* :deep(.ag-bc-balham .ag-row-selected) {
  background: #eff6ff !important;
} */

:deep(.ag-bc-balham .ag-row-selected),
:deep(.ag-bc-balham .ag-row-selected .ag-cell) {
  background-color: #ffff00 !important;
}

/* 랭킹 컬럼 */

:deep(.ag-bc-balham .ag-cell:first-child) {
  font-weight: 600;
}

/* =========================================================
   그리드 우측 정보
========================================================= */

.ranking-info {
  flex-shrink: 0;

  padding: 6px 10px;

  background: #f8fafc;

  border: 1px solid #e5e7eb;
  border-radius: 6px;

  color: #969393;

  font-size: 0.8rem;
}

.ranking-info strong {
  color: #2563eb;
  font-size: 0.8rem;
}

/* =========================================================
   상세 영역
========================================================= */

.detail-card {
  animation: detailOpen 0.25s ease;
}

@keyframes detailOpen {
  from {
    opacity: 0;
    transform: translateY(5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* =========================================================
   반응형
========================================================= */

@media (max-width: 1025px) {
  .layout {
    flex-direction: column;
  }

  .left-form,
  .right-grid {
    width: 100%;
    flex: none;
  }
}

</style>
